export const DEFINE_REVISTA = 'DEFINE_REVISTA'
export const DEFINE_MEDICAMENTO = 'DEFINE_MEDICAMENTO'
